import Vue from 'vue'
import axios from 'axios'
import { authorizationData } from '@/helpers/authUtil'
import env from '@/env'
import { setRequestInfo } from '@/composables/useAxiosRequestDuration'

const $axios = axios.create({
    baseURL: env.VITE_APP_API_URL,
})

$axios.interceptors.request.use(
    (config) => {
        if (!config.headers) {
            config.headers = {}
        }
        config.headers.Authorization = authorizationData()
        config.headers['RequestStartTime'] = new Date().getTime()
        return config
    }, (e) => {
        return Promise.reject(e)
    })

$axios.interceptors.response.use(
    (res) => {
        setRequestInfo(res)

        return res.data
    }, (e) => {
        return Promise.reject(e)
    })

// TODO remove
Vue.prototype.$axios = $axios

export default $axios
